export default {
  entrar: "Entrar",
  senha: "Senha",
  informe: "Informe",
  nome: "Nome",
  cadastro: "Cadastro",
  "cadastre-se": "Cadastre-se",
  cadastrar: "Cadastrar",
  "cadastro-sucesso":
    "Cadastro efetuado com sucesso. Verifique seu e-mail para a confirmação de cadastro.",
  "redefinir-senha": "Redefinir Senha",
  "senhas-diferentes": "Erro de confirmação de senha",
  "confirma-senha": "Confirmação de senha",
  "verifique-seu-email": "Verifique seu email",
  "senha-redefinida-sucesso": "Senha redefinida com sucesso",
  enviar: "Enviar",
  voltar: "Voltar",
  "email-invalido": "O e-mail inserido é inválido",
  "cpf-invalido": "O CPF inserido é inválido",
  "erro-api": "Ocorreu um erro. Por favor, tente novamente.",
  "erro-estimativa-valor":
    "Erro ao estimar o valor da consulta. Por favor, tente novamente.",
  "selecionar-todos": "Selecionar Todos",
  "expandir-todos": "Expandir Todos",
  "ocultar-todos": "Ocultar Todos",
  "valor-base": "Valor Base",
  "subtotal-area": "Subtotal Área",
  "subtotal-documentos": "Subtotal Documentos",
  desconto: "Desconto",
  total: "Total",
  "executar-analise-erro":
    "Erro ao criar consulta. Por favor, tente novamente.",
  "executar-analise-sucesso": "Consulta criada com sucesso!",
  "detalhes-consulta": "Detalhes da consulta:",
  municipio: "Município",
  area: "Área",
  "area-ha": "Área (ha)",
  "area-consultada": "Área Consultada",
  legenda: "Legenda",
  Documento: "{num, plural, one {CPF/CNPJ} other {CPFs/CNPJs}}",
  criterios: "Critérios",
  "ajuda-criterios-1":
    "De acordo com os dados inseridos, selecionamos critérios disponíveis para análise.",
  "ajuda-criterios-2":
    "Você deve selecionar pelo menos um dos critérios para análise. Ao lado de cada critério, você pode consultar o valor por hectare ou por documento.",
  "ajuda-criterios-3":
    "Abaixo da lista de critérios, você pode encontrar o valor total por hectare e por documento, bem como o valor total da consulta.",
  "nome-consulta": "Nome da Consulta",
  "codigo-consulta": "Código da Consulta",
  "ajuda-nome-consulta":
    "Opcionalmente, você também pode inserir um nome para a sua consulta.",
  Executar: "Executar",
  Salvar: "Salvar",
  "ajuda-executar-analise-1":
    "Para executar uma única consulta, você pode selecionar ",
  "ajuda-executar-analise-2":
    "Caso queira gerar várias consultas e executá-las todas ao mesmo tempo, você também pode salvar esta consulta.",
  "erro-inesperado-upload":
    "Erro inesperado ao enviar o arquivo. Por favor, verifique o arquivo e tente novamente.",
  "mensagem-input-analise":
    "Insira os documentos e/ou envie o arquivo com a área a ser consultada. O valor de cada consulta é de {analysisBudget}.",
  "mensagem-input-analise-empresarial":
    "Insira os documentos e/ou envie o arquivo com a área a ser consultada.",
  "relatorios-empresariais":
    "Relatórios",
  "filtrar-por-usuario":
    "Filtrar por usuário",
  "selecione-um-ou-mais":
    "Selecione um ou mais",
  "selecione-um":
    "Selecione um",
  "solicitante-consulta": "Solicitante",
  "procure-por-nome": "Procure por nome",
  "mensagem-intro-video": "Veja como usar o BusCAR",
  "titulo-intro-video": "Como usar o BusCAR",
  "erro-documento-invalido":
    "Não conseguimos validar {num, plural, one {o seguinte documento} other {os seguintes documentos}}",
  "ajuda-analise-documento":
    "Você pode adicionar múltiplos CPFs e CNPJs. Caso já possua essa lista, pode copiar e colar vários documentos separados por vírgula ou ponto-e-vírgula",
  "titulo-cpf-dap": "Por favor, insira a data de nascimento do CPF informado:",
  "dap-data-formatos": "Formatos válidos: DD/MM/AAAA, DD-MM-AAAA ou DD.MM.AAAA.",
  "erro-data-dap": "Data inválida. \n O formato deve ser: DD/MM/AAAA, DD-MM-AAAA ou DD.MM.AAAA.",
  "e-ou": "e/ou",
  "ou": "ou",
  Enviando: "Enviando",
  "adicionar-arquivo": "Adicionar Arquivo",
  "aceitamos-formatos": "Aceitamos arquivos nos formatos:",
  "recibo-car-invalido": "Recibo de CAR INVALIDO! \n Por favor, tente novamente.",
  "recibo-car-erro": "Erro ao vincular Recibo de CAR. \n Por favor, tente novamente.",
  "primeira-opcao-recibo": "Opção 1: Vinculação do CAR por recibo, utilize os formatos:",
  "segunda-opcao-formatos": "Opção 2: Vinculação do CAR por Arquivo:",
  "recibo-car": "Recibo do CAR",
  "primeira-opcao-recibo-formato": "PA-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
  "segunda-opcao-recibo-formato": "PA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX",
  "baixar-template": "Baixar Modelo",
  "formato-shapefile": "Shapefile, zipado ({link})",
  "formato-kml": "Kml ({link})",
  "formato-sicar":
    "{link}, zipado (O SICAR é o sistema de CAR - Cadastro Ambiental Rural - do Serviço Florestal Brasileiro)",
  "um-arquivo-por-consulta": "Você só pode enviar um arquivo por consulta.",
  continuar: "Continuar",
  "erro-verificar-saldo":
    "Erro ao verificar o saldo disponível. Por favor, tente novamente.",
  "saldo-insuficiente": "Saldo insuficiente para realizar a consulta.",
  "nao-encontrado": "Não Encontrado",
  "nao-encontrado-mensagem":
    "Não conseguimos localizar a página que você está procurando.",
  "tente-voltar": "Tente voltar à ",
  "pagina-inicial": "página inicial",
  "pagina-login": "página de login",
  "remover-arquivo": "Remover Arquivo",
  "vincular-recibo": "Vincular o Recibo do CAR",
  "resultado-consulta": "Resultado da Consulta",
  "data-base": "Data Base",
  "data-consulta": "Data da Consulta",
  "ultima-atualizacao": "Última Atualização",
  valor: "Valor",
  'mudancas-termos': "Os nossos Termos e a Política de Privacidade foram atualizados.",
  'mudancas-termos-descricao': "Os termos estão sendo atualizados para melhor se adequar à nova LGPD (Lei Geral de Proteção de Dados). Para continuar o uso do nosso sistema, será necessário o seu consentimento com os novos termos e políticas.",
  "nenhuma-infracao": "Nenhuma sobreposição encontrada",
  "infracoes-encontradas": "Sobreposições encontradas",
  "porcentagem-sobreposicao": "Porcentagem de sobreposição",
  "nenhuma-infracao-documento": "Nenhuma ocorrência encontrada",
  "x-ocorrencias-encontradas": "{num} ocorrência(s) encontrada(s)",
  "cpfs-com-dap": "CPFs que apresentam DAP",
  "sem-titulo": "Sem título",
  "area-intersecao": "Área de Interseção",
  "consulta-pronaf": "Possui Declaração de Aptidão ao Pronaf (DAP) ?",
  "ajuda-pronaf": "Identifique se operação é do tipo Pronaf",
  "documentos-com-problemas": "CPFs",
  "documentos-sem-problemas": "CPFs sem ocorrências",
  descricao: "Descrição",
  fonte: "Fonte",
  "mensagem-processando-consulta":
    "Sua consulta ainda está sendo processada. Alguns critérios podem demorar algumas horas para serem processados.",
  "tipos-criterio": "Tipos de Critérios",
  "pagina-anterior": "Página Anterior",
  "proxima-pagina": "Próxima Página",
  "nenhuma-consulta-encontrada": "Nenhuma consulta encontrada",
  historico: "Histórico",
  "nova-consulta": "Nova Consulta",
  sobre: "Sobre",
  "termos-uso": "Termos de Uso",
  "politica-privacidade": "Política de Privacidade",
  contato: "Contato",
  sair: "Sair",
  "possui-criterio-documento": "possui critério de documento",
  "possui-criterio-area": "possui critério de área",
  "li-e-aceito": "Declaro que li e aceito os",
  "e-a": "e a",
  "validar-conta": "Validar Conta",
  "sucesso-validacao-email": "Conta validada com sucesso",
  "erro-validacao-email": "Houve um problema ao validar sua conta",
  sucesso: "Successo",
  erro: "Erro",
  "sera-cobrado": "Você será cobrado",
  "confirmacao-relatorio": "Confirmação de Relatório",
  processada: "Processada",
  "nao-processada": "Não processada",
  sim: "Sim",
  nao: "Não",
  cancelar: "Cancelar",
  "executar-analise": "Executar Análise",
  "executar-selecionadas": "Executar Selecionadas",
  "executadas-sucesso":
    "{num} {num, plural, one {consulta executada} other {consultas executadas}} com sucesso",
  "executadas-erro":
    "Erro ao executar {num, plural, one {uma consulta com o seguinte erro} other {{num} consultas com os seguintes erros}}:",
  "exportar-como-pdf": "Exportar como PDF",
  endereco: "Endereço",
  fone: "Fone",
  "mensagem-home-office-telefone": "Estamos em home office, ligue-nos no",
  "horario-atendimento": "Horário de atendimento",
  "horario-atendimento-descricao":
    "de {de} a {ate}, horário de Belém-PA (UTC-3)",
  "mensagem-sobre-1":
    "O BusCAR é uma aplicação web que permite consultar a situação socioambiental de um imóvel rural registrado no Cadastro Ambiental Rural (CAR) ou qualquer área de seu interesse no território nacional, de forma prática e rápida.",
  "mensagem-sobre-2":
    "A aplicação dispõe de uma lista de critérios socioambientais que são requeridos por instituições financeiras, pelo mercado do agronegócio, e cada vez mais, pelo crescente número de consumidores conscientes.",
  "perguntas-frequentes": "Perguntas Frequentes",
  fechar: "Fechar",
  "ir-para-contato": "Ir para a página de contato.",
  todos: "Todos",
  personalizado: "Personalizado",
  "bases-disponiveis": "Bases Disponíveis",
  "usuarios-unicos": "Usuários únicos",
  "usuarios-consultas": "Usuários com consultas",
  "consultas": "Consultas totais",
  "consultas-normais": "Consultas normais",
  "consultas-empresariais": "Consultas empresariais",
  "contas-antes-lancamento": "Contas antes do lançamento",
  "contas-pos-lancamento": "Contas pós lançamento",
  "filtrar-por-data": "Filtrar por data",
  "ate": "até",
  "todos-usuarios": "Todos usuários",
  "vincular-usuario-pj": "Vincule o usuário à uma PJ",
  "grafico": "Gráfico",
  "usuarios": "Usuários",
  "entrou-em": "Entrou em",
  "numero-total-consultas": "Nº total de consultas",
  "primeira-consulta": "Primeira consulta",
  "ultima-consulta": "Última consulta",
  "sem-consulta": "Sem consulta",
  "consultas-feitas": "Consultas feitas",
  "consultas-restantes": "Consultas restantes",
  "total-usuarios": "Total de usuários vinculados",
  "informacoes": "Informações",
  "conta-pj-master": "Conta PJ master",
  "conta-pj-direta": "Conta PJ direta",
  "plano-atual": "Plano atual",
  "dia-bilhetagem": "Dia de bilhetagem",
  "historico-consultas": "Histórico de consultas",
  "consultas-mensais": "consultas mensais",
  "tolerancia": "tolerância",
  "administrador": "Administrador",
  "confirmacao-reenvio": "Confirmação de Reenvio",
  "reenvio-email-usuario": "Reenviar confirmação de e-mail do usuário {email}",
  "exportar-coordenadas": "Coordenadas em CSV",
  "saldo": "Saldo",
  "processando-pagamento": "Processando Pagamento",
  "verificando-status-pagamento": "Verificando o status do seu pagamento...",
  "carregando": "Carregando...",
  "pagamento-realizado": "Pagamento Realizado!",
  "pagamento-confirmado": "Pagamento Confirmado!",
  "pagamento-sucesso-mensagem": "Seu pagamento foi processado com sucesso. Os créditos já foram adicionados à sua conta e você já pode utilizá-los.",
  "nota": "Nota:",
  "pagamento-info-boleto-pix": "Para pagamentos via boleto ou PIX, os créditos serão adicionados após a confirmação do pagamento pelo banco, o que pode levar alguns minutos.",
  "nova-analise": "Nova Análise",
  "adicionar-fundos": "Adicionar Fundos",
};
